
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AppBar, Badge, Box, Button, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText, Stack, Toolbar, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { useAuthStore, useCarritoClienteStore, useGlobalValueStore, useModalStore } from '../../stores';
import { iconos } from '../../data';
import { useListCarritoXUser } from '../../hooks/cache';


const empresa = require.context('../../assets/empresa', true);
const menuItems = [
    { label: "Inicio", path: "/" },
    { label: "Productos y Servicios", path: "/categorias" },
    { label: "Contáctanos", path: "/contactos" },
    // { label: "Rastrear O.P.", path: "/restrearop" }
];


export const Navbar = () => {

    const navigate = useNavigate();
    const theme = useTheme();
    const { cliente } = useAuthStore();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { cambioRolVenta } = useGlobalValueStore();
    const { modalToggleLateral } = useModalStore();
    const { items } = useCarritoClienteStore();
    const { data } = useListCarritoXUser(cliente?.id);
    const itemsClienteCarrito = (cliente) ? data?.length : items?.length;

    const [open, setOpen] = useState(false);


    useEffect(() => {
        cambioRolVenta('cliente');
    }, [])


    const toggleDrawer = () => { setOpen(!open);};


    return (
        <>
        <AppBar className="barra">
            <Toolbar sx={{ height:'100%' }}>
                {/* Logo */}
                <Stack direction="row" spacing={3} alignItems="center">
                    <Box component={NavLink} to="/" sx={{ display:"flex", alignItems:"center", height:"100%" }}>
                        <Box component="img" src={empresa("./svtextoblanco.png")} alt="Logo"
                            sx={{ height:50, width:"auto", display:"block", mt:0.5 }}
                        />
                    </Box>

                    {(!isMobile) &&
                        <Stack direction="row" spacing={1}>
                        {menuItems.map((item) => (
                            <Button key={item.path} component={NavLink} to={item.path} sx={{ color:"#fff", textTransform:"none" }}>
                                {item.label}
                            </Button>
                        ))}
                        </Stack>
                    }
                </Stack>

                <Box sx={{ flexGrow: 1 }} />
                
                <Stack direction="row" spacing={2} alignItems="center">
                    <IconButton onClick={() => modalToggleLateral(true)} sx={{ color:"#fff", padding:0.8 }}>
                        <Badge badgeContent={itemsClienteCarrito || 0} sx={{'& .MuiBadge-badge': {backgroundColor:'#4caf50', color:'white'} }}>
                            { iconos['carrito'] }
                        </Badge>
                    </IconButton>

                    {(!isMobile) && 
                    <>
                    {(cliente) 
                    ?   <Button component={NavLink} to="/dashboard" sx={{ textTransform:"none" }} variant="contained" color="primary">
                            Mi Perfil
                        </Button>

                    :   <>
                        <Tooltip title="Ingreso Cliente" arrow>
                            <IconButton component={NavLink} to="/login" sx={{backgroundColor:"primary.main", padding:0.8 }}>
                                { iconos['user'] }
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Ingreso Admin" arrow>
                            <IconButton onClick={() => navigate('/admin/login')} color='secondary.main' sx={{ padding:0.8 }}>
                                { iconos['admin'] }
                            </IconButton>
                        </Tooltip>
                        </>
                    }
                    </>
                    }

                    {(isMobile) &&
                    <IconButton edge="end" onClick={ toggleDrawer } sx={{ color:"#fff", padding:0.8 }}>
                        { iconos['menu'] }
                    </IconButton>
                    }
                </Stack>
            </Toolbar>
        </AppBar>

        <Toolbar sx={{height:69}} />

        <Drawer anchor="right" open={open} onClose={ toggleDrawer }>
            <Box sx={{ width:250 }} role="presentation">
                <List>
                    {menuItems.map((item) => (
                    <ListItem key={item.path} disablePadding>
                        <ListItemButton component={NavLink} to={item.path} onClick={toggleDrawer}>
                        <ListItemText primary={item.label} primaryTypographyProps={{ textAlign: "center" }} />
                        </ListItemButton>
                    </ListItem>
                    ))}

                    {(cliente) 
                    ?   <ListItem disablePadding>
                            <ListItemButton component={NavLink} to="/dashboard" onClick={toggleDrawer}>
                                <ListItemText primary="Mi Perfil" primaryTypographyProps={{ textAlign: "center" }} />
                            </ListItemButton>
                        </ListItem>
                    :   <>
                        <ListItem disablePadding>
                            <ListItemButton component={NavLink} to="/login" onClick={toggleDrawer}>
                                <ListItemText primary="Ingreso Cliente" primaryTypographyProps={{ textAlign: "center" }} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton onClick={() => { toggleDrawer(); navigate('/admin/login') }}>
                                <ListItemText primary="Ingreso Admin." primaryTypographyProps={{ textAlign: "center" }} />
                            </ListItemButton>
                        </ListItem>
                    </>
                    }
                </List>
            </Box>
        </Drawer>
        </>
    )
}
